import { useTranslation } from 'react-i18next';
import {
  Container,
  StyledHeader as Header,
  StyledCard as Card,
  StyledInfoBox as InfoBox,
  StyledParagraph,
} from './styles';
import { useSetTitleOnLoad } from 'hooks/useSetTitleOnLoad';
import { Button } from '@kizen/kds/Button';
import { Spacer } from '@kizen/kds/Spacer';
import { useSelector } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Typography } from '@kizen/kds/Typography';
import { useBillingState } from 'utility/billing';

export const PaymentRequiredPage = () => {
  const { t } = useTranslation();

  useSetTitleOnLoad(t('Payment Required'));

  const business = useSelector((s: any) => s.authentication.chosenBusiness);
  const customAppName = business?.entitlements?.custom_branding?.product_name;

  const { isOkay } = useBillingState();

  if (isOkay) {
    return <Redirect to="/" />;
  }

  return (
    <Container>
      <Card>
        <Header type="header" margin="lg">
          {t('Payment Required')}
        </Header>
        <InfoBox>
          <StyledParagraph className="text-center">
            {t(
              'To get started using {{appName}}, please add a payment method.',
              {
                appName: customAppName || 'Kizen',
              }
            )}
          </StyledParagraph>
        </InfoBox>
        <Spacer size={20} />
        <div className="flex justify-center">
          <Link to="/settings/billing/details">
            <Button color="secondary">{t('Add Payment Method')}</Button>
          </Link>
        </div>
        <Spacer size={30} />
        <div className="flex justify-center">
          <Typography variant="link" href="/logout">
            {t('Logout')}
          </Typography>
          <Spacer size={30} mode="vertical" />
          <Typography truncate variant="link" href="/choose-business">
            {t('Switch Business')}
          </Typography>
        </div>
      </Card>
    </Container>
  );
};
